export const LOGIN_SOCIAL_BAR_NAMESPACE = 'login_social_bar';
export const OPTION_VALUE_TEXT = 'login_social_bar_choose_option_title';
export const CHOOSE_OPTION_TEXT_DEFAULT = 'Choose an option';

export const LOG_OUT_TEXT = 'login_social_bar_log_out_action';

export const CUSTOM_LOGGED_IN_TEXT = 'login_social_bar_custom_logged_in_text';

export const LOGGED_OUT_TEXT = 'login_social_bar_log_in_action';

export const LOGGED_IN_TEXT = 'login_social_bar_logged_in_greeting';

export const ACCOUNT_BUTTON_ARIA_LABEL_DEFAULT = '{userName} account';

export const TRANSLATION_VALUE_DEFAULTS = {
  loggedOutText: 'Log In',
  logOutText: 'Log Out',
  loggedInText: 'Hello',
  customLoggedInText: 'Account',
} as const;
